import React, { useEffect } from 'react';
import useScrollTopOnRoute from './hooks/useScrollTopOnRoute';
import Footer from './components/common/Footer';
// import Header from './components/common/Header';
import {
	// BrowserRouter as Router,
	// Switch,
	useLocation,
	// Route,
} from 'react-router-dom';
// import ErrorPage from './components/common/ErrorPage';
// import Login from './components/pages/Login';

/* [CF 2026-08-09] Client: the footer belongs on the landing page and the
   category LISTINGS only — not on detail pages, the account/owner screens or
   the auth pages. Exact matches on purpose: `/user-garages-detail/:id` starts
   with `/user-garages`, so a prefix test would put the footer back on every
   detail page. */
const FOOTER_ROUTES = new Set([
	/* [CF 2026-08-09] The landing page is deliberately NOT in this list. It is a
	   locked full-screen slider, so a footer underneath it can only be reached
	   by scrolling past the slider — which reintroduces the very scroll the
	   page was fixed to avoid. Client asked for it to be hidden there. */
	'/user-cars-for-sale',
	'/user-car-dealers',
	'/user-rent-car',
	'/user-car-wash',
	'/user-car-protection',
	'/user-spare-parts',
	'/user-quick-services',
	'/user-garages',
	'/user-driving-schools',
	'/user-car-insurance',
	'/user-air-conditioning',
	'/user-taxi',
	'/user-towing',
]);

const Routes = ({ children }) => {
	let location = useLocation();
	const showFooter = FOOTER_ROUTES.has(location.pathname.replace(/\/+$/, '') || '/');

	// [CF 2026-08-17 #5] See src/hooks/useScrollTopOnRoute.js — the logic was
	// duplicated here and in Routes2.js, which had already drifted.
	useScrollTopOnRoute(location.pathname);

	/* [CF 2026-08-17] custom.css is injected at RUNTIME rather than linked from
	   index.html, and the `?v=` token is the cache-bust — it must be bumped in
	   BOTH this file and Routes2.js or browsers keep serving the old sheet.

	   This used to append a brand-new <link> on EVERY route change, so a user
	   moving around the site accumulated dozens of identical stylesheets in
	   <head>, each one re-parsed. Now it is added once and only once. */
	useEffect(() => {
		if (location.pathname === '/') return;
		const href = 'assets/css/custom.css?v=cf0817g';
		if (document.querySelector(`link[href="${href}"]`)) return;
		const sheet = document.createElement('link');
		sheet.rel = 'stylesheet';
		sheet.href = href;
		sheet.type = 'text/css';
		document.head.appendChild(sheet);
	}, [location]);

	return (
		<div
			style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
		>
			{/* <Header></Header> */}
			{/* [CF 2026-07-28] App.js renders <Header/> INSIDE this layout whenever
			    pathname !== '/', and that header is `.wsmobileheader`
			    position:fixed (56px) on mobile. Nothing offset the content, so
			    page content rendered BEHIND it — visible when overscrolling.
			    Use the SAME condition as the header so the home page (no
			    header) gets no offset. */}
			<div
				className={location.pathname !== '/' ? 'cav-app-content' : undefined}
				style={{ flex: '1 0 auto' }}
			>
				{children}
			</div>

			{showFooter && <Footer></Footer>}
		</div>
	);
};

export default Routes;
